import { SearchResultLayoutDesktop } from '../templates/components/SearchResultLayoutDesktop/templates';
import { SearchResultLayoutMobile } from '../templates/components/SearchResultLayoutMobile/templates';
import { ProductSummaryShelf } from '../templates/components/ProductSummaryShelf/templates';
import { BannerSectionGroup } from '../templates/components/BannerSectionGroup/templates';
import { ProductSpecificationSection } from '../templates/components/ProductSpecificationSection/templates';
import { ProductImagesDetailsGroup } from '../templates/components/ProductImagesDetailsGroup/templates';
import { HeaderDesktop } from '../templates/components/HeaderDesktop/templates';
import { HeaderMobile } from '../templates/components/HeaderMobile/templates';
import { FooterDesktop } from '../templates/components/FooterDesktop/templates';
import { FooterMobile } from '../templates/components/FooterMobile/templates';
import { SliderLayout } from '../templates/components/SliderLayout/templates';
import { ProductSummaryList } from '../templates/components/ProductSummaryList/templates';
import { BreadcrumbGroup, breadCrumbReference } from '../templates/components/BreadcrumbGroup/templates';
import { ProductDescriptionGroup } from '../templates/components/ProductDescriptionGroup/templates';
import { RelatedProducts } from '../templates/components/RelatedProducts/templates';
import { TipbarGroup } from '../templates/components/TipbarGroup/templates';
import { ModalNewsletter } from '../templates/components/ModalNewsletter/templates';
import { MinicartGroup } from '../templates/components/MinicartGroup/templates';
import { ReviewsGroup } from '../templates/components/ReviewsGroup/templates';
import { SearchNotFoundGroup } from '../templates/components/SearchNotFoundGroup/templates';
import { BuyTogetherGroup } from '../templates/components/BuyTogetherGroup/templates';
import { StoreMenuDesktop } from '../templates/components/StoreMenuDesktop/templates';
import { StoreMenuMobile } from '../templates/components/StoreMenuMobile/templates';
import { InstitutionalGroup } from '../templates/components/InstitutionalGroup/templates';
import { RichTextRow } from '../templates/components/RichTextRow/templates';

export default function pagesJsonComponent() {
	return {
		HomePage: (templateId) => [
			SliderLayout(templateId),
			TipbarGroup(templateId),
			ProductSummaryList(templateId),
			BannerSectionGroup(templateId),
		],
		Header: (templateId) => [HeaderDesktop(templateId), HeaderMobile(templateId)],
		Footer: (templateId) => [FooterDesktop(templateId), FooterMobile(templateId)],
		Breadcrumb: (templateId) => [BreadcrumbGroup(templateId)],
		ProductPage: (templateId) => [
			breadCrumbReference(),
			ProductImagesDetailsGroup(templateId),
			ProductDescriptionGroup(templateId),
			ProductSpecificationSection(templateId),
			RelatedProducts(templateId),
			ReviewsGroup(templateId),
			BuyTogetherGroup(templateId),
		],
		SearchPage: (templateId) => [SearchResultLayoutDesktop(templateId), SearchResultLayoutMobile(templateId)],
		SearchNotFound: (templateId) => [SearchNotFoundGroup(templateId)],
		ShelfPage: (templateId) => [ProductSummaryShelf(templateId)],
		ModalPage: (templateId) => [ModalNewsletter(templateId)],
		MinicartPage: (templateId) => [MinicartGroup(templateId)],
		StoreMenu: (templateId) => [StoreMenuDesktop(templateId), StoreMenuMobile(templateId)],
		CallCenter: () => [InstitutionalGroup(4)],
		Institutional: () => [InstitutionalGroup(5)],
		ProductNotFound: (templateId) => [
			RichTextRow(templateId, {
				FlexLayoutRow: { mzTitle: 'MZ | Produto não encontrado Título', horizontalAlign: 'center' },
				RichText: { textAlignment: 'CENTER', textPosition: 'CENTER', text: '## Página não encontrada ' },
			}),
			RichTextRow(templateId, {
				FlexLayoutRow: { mzTitle: 'MZ | Produto não encontrado', horizontalAlign: 'center' },
				RichText: {
					textAlignment: 'CENTER',
					textPosition: 'CENTER',
					text: '#### O que acha de realizar uma nova busca? ####\n Tente fazer sua busca seguindo estas dicas;\nVerifique se ocorreu algum erro de digitação;\n Tente utilizar uma única palavra;\nReescreva sua busca utilizando termos mais genéricos.',
				},
			}),
			RichTextRow(templateId, {
				FlexLayoutRow: { mzTitle: 'MZ | Voltar para Home', horizontalAlign: 'center' },
				RichText: { textAlignment: 'CENTER', textPosition: 'CENTER', text: '[Voltar para a home](/)' },
			}),
		],
	};
}
